export interface MessageProps {
  [key: string]: string;
}

export interface Countries {
  value: string;
  label: string;
}

export interface Options {
  value: string;
  label: string;
  disabled?: boolean;
  disableMark?: string;
}

export interface PlatformOptions {
  value: string;
  label: string;
  disabled?: boolean;
  platformDisabled?: boolean;
  hasExternalAuth?: boolean;
}

interface AuthIds {
  id: string;
  type: string;
}

export interface ExternalAuths {
  accountId?: string;
  externalAuthId?: string;
  externalAuthIdType?: string;
  authIds?: AuthIds[];
  externalDisplayName?: string;
  type: string;
  dateAdded?: string;
  regionInfo?: string;
}

export interface LoginModal {
  warningContent: string;
}

export interface RedeemSectionData {
  unLoggedInContent: string;
  bgImage: string;
  moneyImage: string;
  loggedInContent: string;
  toolTipDescription: string;
  toolTipImage: string;
  psnToolTip: string;
  platformToolTip: string;
  inputPlaceholder?: string;
  _type?: string;
}

export interface PosaRedeemConfigs {
  psnOptions: string;
  enableRegionAutoDetection: boolean;
  extra: string;
}

interface SecondaryCode {
  code?: string;
}

interface SuccessPage {
  bgImage: string;
  contentLeftColumn: string;
  contentRightColumn: string;
  disableStepsButton: boolean;
  visitLink?: string;
  visitText?: string;
}

export interface ConnectedPlatforms {
  platform: PosaPlatforms;
  redeemable: boolean;
  regionInfo?: string;
  regionSupported?: boolean;
  platformDisabled?: boolean;
}

export interface PosaRedeemStore {
  verifying: boolean;
  errorCode: string | null;
  code: string;
  codeVerified: boolean;
  offer: any;
  page: {
    configs: PosaRedeemConfigs;
    generalSuccess: SuccessPage;
    psnSuccess: SuccessPage;
    xblSuccess: SuccessPage;
  };
  externalAuths: ExternalAuths[];
  psnCountry: string;
  platform: string;
  secondaryCode?: SecondaryCode;
  redeemed: boolean;
  connectedPlatforms?: ConnectedPlatforms[];
  showConfirm?: boolean;
  bonusOffers?: any;
}

export interface TrackEventObject {
  link?: string;
}

export interface Wallets {
  balance: string;
  walletId: string;
}

export enum PosaPlatforms {
  EPIC = 'EPIC',
  MOBILE = 'MOBILE',
  PSN = 'PSN',
  SWITCH = 'SWITCH',
  XBL = 'XBL',
}

export interface GiftcardConfig {
  posaGiftCardBannerShow: boolean;
  posaGiftCardCardShow: boolean;
  posaGiftCardRedeemUrl: string;
}
